import PliMembersViewController from "./pli-members-view-controller";

class SecureYourAccountViewController extends PliMembersViewController {
  handleBackButtonClick() {
    this.appData.prevScreen(2);
    return;
  }
}

export default SecureYourAccountViewController;
